import { useCallback, useEffect, useState, } from 'react';
const NAMESPACE = 'scenic-rim-map';
const namespaceKey = (key) => `${NAMESPACE}-${key}`;
const saveState = (key, state) => {
    const nsKey = namespaceKey(key);
    sessionStorage.setItem(nsKey, JSON.stringify(state));
};
const loadState = (key, fallback) => {
    const nsKey = namespaceKey(key);
    try {
        const json = sessionStorage.getItem(nsKey);
        return json ? JSON.parse(json) : fallback;
    }
    catch (err) {
        sessionStorage.removeItem(nsKey);
        return fallback;
    }
};
export default function useSessionState(key, initial) {
    const [state, setLocalState] = useState(loadState(key, initial));
    // Set state locally and persist to sessionStorage
    const setState = useCallback((setter) => {
        const nextState = setter instanceof Function ? setter(state) : setter;
        saveState(key, nextState);
        setLocalState(nextState);
    }, [key, state, setLocalState]);
    // Update state if key changes
    useEffect(() => {
        setLocalState(loadState(key, initial));
    }, [key, setLocalState]);
    return [state, setState];
}
